<template>
    <v-card>
        <v-card-title>
            <v-icon left>mdi-account-cog</v-icon>
            Permisos por Usuario
            <v-spacer />
        </v-card-title>
        <v-card-subtitle>
            Gestión de permisos adicionales o revocados por usuario y empresa
        </v-card-subtitle>
        <v-card-text>
            <user-permissions-list
                @edit="openEdit"
            />

            <user-permissions-edit
                v-if="!!selectedEntry"
                :open="!!selectedEntry"
                :userId="selectedEntry.userId"
                :companyId="selectedEntry.companyId"
                :userName="selectedEntry.userName"
                :companyName="selectedEntry.companyName"
                :roleId="selectedEntry.roleId"
                :roleName="selectedEntry.roleName"
                @saved="onSaved"
                @close="selectedEntry = null"
            />

            <snackbar v-model="flash" />
        </v-card-text>
    </v-card>
</template>

<script>
import UserPermissionsList from '../UserPermissionsList'
import UserPermissionsEdit from '../UserPermissionsEdit'
import { Snackbar } from '@dracul/common-frontend'

export default {
    name: 'UserPermissionsCrud',
    components: { UserPermissionsList, UserPermissionsEdit, Snackbar },
    data() {
        return {
            selectedEntry: null,
            flash: null
        }
    },
    methods: {
        openEdit(entry) {
            this.selectedEntry = entry
        },
        onSaved() {
            this.flash = 'Permisos actualizados correctamente'
            this.selectedEntry = null
        }
    }
}
</script>
